const topics = [
  { label: '古装大剧', hot: true },
  { label: '悬疑烧脑', hot: true },
  { label: '甜宠言情', hot: false },
  { label: '都市职场', hot: false },
  { label: '奇幻冒险', hot: true },
  { label: '历史正剧', hot: false },
  { label: '韩剧精选', hot: true },
  { label: '青春校园', hot: false },
  { label: '谍战风云', hot: false },
  { label: '喜剧搞笑', hot: false },
  { label: '武侠经典', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-18 bg-background-50">
      <div className="max-w-[1024px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">热门话题</h2>
          <p className="text-sm text-foreground-500">追剧圈最火的讨论都在这里，看看大家都在聊什么</p>
        </div>
        <div className="flex flex-wrap justify-center gap-2 md:gap-3">
          {topics.map((topic) => (
            <a
              key={topic.label}
              href="#cards"
              className={`whitespace-nowrap inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer ${
                topic.hot
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              {topic.label}
              {topic.hot && (
                <i className="ri-fire-line text-xs text-accent-500"></i>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}